/**
 * SEO 配置 - chat (日本語)
 */

export default {
    chat: {
        title: 'AIチャット - マルチモデルアシスタント | WeryAI',
        description:
            'WeryAIでトップAIモデルとチャット。複数ウィンドウで回答を並べて比較。画像・動画・音楽を一つのAIワークスペースから生成。無料で体験。',
        keywords:
            'AIチャット, AIアシスタント, マルチモデルチャット, AIチャットボット, AI比較, 並列AIチャット, GPT代替, AIワークスペース, WeryAI',
        og_title: 'AIチャット - マルチモデルアシスタント | WeryAI',
        og_description:
            'トップAIモデルとチャットし、回答を並べて比較。画像・動画などを一つのワークスペースから生成。WeryAIで無料体験。',
        twitter_title: 'AIチャット - マルチモデルアシスタント | WeryAI',
        twitter_description:
            'トップAIモデルとチャットし、回答を並べて比較。画像・動画などを一つのワークスペースから生成。WeryAIで無料体験。',
    },
}
